<ng-container *ngIf="!storyLoaded; else loaded">
  <anon-loading [height]="250"></anon-loading>
</ng-container>

<ng-template #loaded>
  <article>
    <anon-editor
      [config]="editorConfig"
      (editorChange)="onChange($event)"
      (readyChange)="putEditorInFocus($event)"
      [story]="this.story.content"></anon-editor>
  </article>
  <button mat-raised-button color="primary" (click)="previewStory()">Preview</button>
  <button mat-button (click)="convertMarkdownToHtml()">Convert Markdown to HTML</button>
</ng-template>
